import { Node } from '@xyflow/react'
import { NodeTypes } from '@/pages/RenewedPipeline/Nodes/types'
import { ModelValueType } from '@/pages/const'

/**
 * Node 타입:
 * id (노드의 ObjectId - 고로 해당 이아디와 data 객체 밑 _id는 동일)
 * type (dataset | labeling | review | train | validation | inference),
 * position ({ x: number, y: number }),
 * data (노드 get 해온 정보)
 * */
export interface PipelineState {
  nodes: Node[],
  placeholder: {
    position: { x: number, y: number },
    sourceId?: string,
    sourceType?: NodeTypes,
    sourceData?: any,
    isContextBound?: boolean,
  } | undefined,
  tasksInProgress: {
    type: ClientTaskTypes,
    nodeId: string,
    modelType?: ModelValueType
  }[],
  copiedNode: { id: string, nodeType: NodeTypes, isCopyAll: boolean } | undefined,
  copiedModelVersion: { modelVersionId: string, position?: { x: number, y: number } } | undefined
  runningTask: { taskId: string | undefined, refetch: boolean, temporaryDisableFlag: boolean },
  openSidePanel: boolean
  openSettings: boolean
  isDataDriftNodeCreated: boolean
  pipelineWarningDialog: { title: string; message: string, isOpen: boolean }
  focusedNode: FocusedNode | undefined
  zoomLevel: number
  hasUserUploadedThumbnail: boolean
  isOpsView: boolean
  projectReferenceTime: {
    referenceHour: number
    referenceMinute: number
    referenceSecond: number
    timezone: string
  }
}

export type FocusedNode = {
  id: string
  nodeType: NodeTypes
  position: { x: number, y: number }
  isActive: boolean
  openDrawer: boolean
}

export type ClientTaskTypes = 'train' | 'validation' | 'inference' | 'preprocessingResult'

export const INITIAL_STATE: PipelineState = {
  nodes: [],
  placeholder: undefined,
  tasksInProgress: [],
  copiedNode: undefined,
  copiedModelVersion: undefined,
  runningTask: { taskId: undefined, refetch: false, temporaryDisableFlag: false },
  openSidePanel: false,
  openSettings: false,
  isDataDriftNodeCreated: false,
  pipelineWarningDialog: { title: '', message: '', isOpen: false },
  focusedNode: undefined,
  zoomLevel: 1,
  hasUserUploadedThumbnail: false,
  isOpsView: false,
  projectReferenceTime: {
    referenceHour: 0,
    referenceMinute: 0,
    referenceSecond: 0,
    timezone: 'Asia/Seoul',
  },
}
